import React, { useCallback } from 'react';
import { CreateUserRequest2, IStore, IUser, UserClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { GenericEditor } from '../GenericEditor';
import { SingleUserEditor } from './SingleUserEditor';
import "./UserEditor.scss";


export function UserEditor(props: {
    chainId: number;
    stores: IStore[] | undefined;
}) {

    const chainId = props.chainId;
    const client = useClient(UserClient);
    const getterFunc = useCallback(
        () => client.getUsers(chainId)
            .then(response => response.users),
        [client, chainId]
    )

    function editorFunc(user: IUser, onChange: () => void, updateCount: number) {
        return (
            <SingleUserEditor user={user}
                onChange={onChange}
                key={`${user.id} ${updateCount}`}
                stores={props.stores}
                />

            )
    }

    async function newUser(): Promise<string | undefined> {
        const username = window.prompt("username");
        if (!username)
            return undefined;
        const response = await client.createUser(new CreateUserRequest2({
            chainId: props.chainId,
            username: username
        }));
        return response.userId;
    }

    return (
        <GenericEditor<IUser, string>
            getterFunc={getterFunc}
            nameFunc={u => u.username}
            editorFunc={editorFunc}
            className="user-editor no-right-menu"
            newHandler={{
                buttonName: "Create new User...",
                onClick: newUser
            }}
        />
    );
}
